import { Grid } from '@mui/material';
import { NotificationScreen } from '@tassat/layout';
import React from 'react';

import authService from 'Lib/auth/AuthService';
import { useClientLogos } from 'SharedComponents/hooks/useClientLogos';
import { useClientThemeData } from 'SharedComponents/hooks/useClientThemeData';

import type { OfflineProps } from '.';

export const Offline = (props: OfflineProps) => {
    const { classes } = props;

    const clientInfo = useClientThemeData();
    const clientLogoUrls = useClientLogos();

    React.useEffect(() => {
        window.addEventListener('online', internetRestored);

        return () => {
            window.removeEventListener('online', internetRestored);
        };
    }, []);

    const internetRestored = () => {
        authService.logout();
    };

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
        >
            <NotificationScreen
                clientLogoUrl={clientLogoUrls.ApplicationLogoUrl}
                headerLogoHeight={65}
                messages={[
                    'You have been disconnected from the internet for an extended period. ' +
                    'Please login again once internet connect has returned.',
                    'Please contact us for assistance at any time, 24 hours a day, 7 days a week.'
                ]}
                subtitle='Your Gateway to the Future of Digital Financial Services'
                supportEmail={clientInfo.support.contactInfo.email || '#'}
                supportPhone={clientInfo.support.contactInfo.phoneDirect ||
                    clientInfo.support.contactInfo.phoneTollFree ||
                    'Call support line'}
                title='Offline'
                type='prop'
            />
        </Grid>
    );
};